<template>
	<div
			:class="{ 'has-focus': hasFocus }"
			@click="$refs.searchInput.focus()"
			class="variable-in-use"
			v-if="variable"
	>
        <span class="count">
            {{count}}x
        </span>
		<span :title="variable.name" class="name">
            {{name}}:
        </span>
		<input :disabled="variable.custom"
			:placeholder="variable.custom ? this.$t('variables.calculated') : this.$t('variables.enter')"
			@blur="hasFocus = false"
			@focus="hasFocus = true"
			ref="searchInput"
			v-model="value"
		/>
	</div>
</template>

<script>
	import EventBus from '@/assets/js/eventBus.js'
	import debounce from 'lodash/debounce'

	export default {
		props: ['variable', 'count'],
		data() {
			return {
				onValueChange: debounce(value => {
					this.variable.value = value
					this.$store.dispatch('getTemplatePreview', {
						template: this.$store.state.template,
						variables: this.$store.state.templateVariables
					}).then(preview => {
						// this.$store.state.templatePreview = preview
						this.$store.commit("setTemplatePreview", preview);
					})
					EventBus.$emit('variable-change', this.variable)
				}, 500),
				hasFocus: false
			}
		},
		computed: {
			name() {
				// if this.variable.name -> contains ' _ ' and does not have a displayName, we should assume that its an extraVariable?
				if(!this.variable.displayName && this.variable.name.includes('_')) return this.variable.name.substring(this.variable.name.lastIndexOf('_') +1,this.variable.name.length-1 ) // Formatting the extra-variables
				else return this.variable.displayName ? this.variable.displayName : this.variable.name.replace(/[{}]/g, '');
			},
			value: {
				get() {
					return this.variable.value
				},
				set(value) {
					this.onValueChange(value)
				}
			}
		}
	}
</script>

<style lang="less">
	.variable-in-use {
		display: flex;
		align-items: center;
		color: #8F979C;
		padding: 0 0 0 45px;
		line-height: 30px;
		position: relative;

		.count {
			position: absolute;
			width: 45px;
			left: 0;
			text-align: center;
			display: none;
		}

		.name {
			font-weight: 500;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			flex: 1 0 auto;
		}

		input {
			// flex: 0;
			background: transparent;
			border: none;
			outline: none;
			color: inherit;
			padding: 0 0 0 10px;
		}

		&:hover, &.has-focus {
			background-color: rgba(143, 151, 156, .5);
			color: #fff;

			.name {
				flex: 1 1 auto;
			}

			input {
				flex-grow: 1;

				&::placeholder {
					color: #fff;
				}

			}
		}

		&:hover .count {
			display: block;
		}

		&.align-right{
			input{
				text-align: right;
				padding-right: 10px;
			}
		}
	}

</style>


